// on importe le modèle pour pouvoir le new-er (utile à la validation)
import SiteCaracteristiquesTransporteur from './site.caracteristiques.transporteur.model';

export default class SiteCaracteristiquesTransporteurController {
	// l'injection de dépendances se fait via le mot clé static
	// c'est une mécanique angularJS

	static $inject = ['_', 'SitesTypesService', 'notification', '$timeout', '$scope', 'Interpreteur', 'SitesService'];

	// le constructeur est la seule fonction qui reçoit les dépendances
	constructor(_, SitesTypesService, notification, $timeout, $scope, Interpreteur, SitesService) {
		// on publie les dépendances dans this
		// pour pouvoir s'en servir dans les autres méthodes du controller
		this._ = _;
		this.SitesTypesService = SitesTypesService;
		this.notification = notification;
		this.$timeout = $timeout;
		this.$scope = $scope;
		this.Interpreteur = Interpreteur;
		this.SitesService = SitesService;
	}

	// cette fonction est appelée automatiquement à la création du component
	// par la mécanique interne angularJS
	async $onInit() {
		// on initialise les variables du controller
		this.loading = false;
		this.typeFormat = this.typeFormat || [];
		this.site = this.site || {};
		this.niveauVisibilite = 0;
		this.caracteristiquesTransporteur = new SiteCaracteristiquesTransporteur(this.site.caracteristiquesTransporteur);
		this.Interpreteur.init(this.site, null);
		this.Interpreteur.formatCaract = this.typeFormat;
		this.initConditions = false;
		const _this = this;
		this.$scope.$watch('$ctrl.site.entete.niveauVisibiliteTransporteur', function () {
			_this.niveauVisibilite = _this.site.entete.niveauVisibiliteTransporteur;
		});

		this.hasUserAccess = await this.SitesService.checkProfilRights(!!this.site?.id, 'sitetransp');
	}

	// cette fonction est appelée automatiquement à la destruction du component
	// par la mécanique interne angularJS
	$onDestroy() {
		this.$timeout.cancel(this.typeFormatTimeout);
	}

	// cette fonction est appelée automatiquement
	// dans le cas où une des propriétés du component :
	// 1. est bindée en one-way '<'
	// 2. est modifiée d'une façon ou d'une autre
	$onChanges(objChanges) {
		if (objChanges.typeId) {
			if (!objChanges.typeId.isFirstChange()) {
				this.caracteristiquesTransporteur = new SiteCaracteristiquesTransporteur();
			}

			this.getTypeFormat(objChanges.typeId.currentValue);
		}
	}

	// cette fonction est appelée automatiquement
	// a chaque digest (dirty check) d'angular
	async $doCheck() {
		//recalcul des conditions d'affichage dès qu'on a les infos pour le faire
		if (!this.initConditions && this.typeFormat && this.typeFormat.length > 0) {
			await this.recalculeConditions();
			this.initConditions = true;
		}
		if (!angular.equals(this.caracteristiquesTransporteur, this.site.caracteristiquesTransporteur)) {
			this.onUpdate({
				caracteristiquesTransporteur: angular.copy(this.caracteristiquesTransporteur)
			});
		}
	}

	async getTypeFormat(typeId) {
		if (typeId) {
			// on démarre l'animation de loading avant le chargement des données
			this.startLoading();

			// on encapsule l'appel serveur dans un try...catch pour récupérer les erreurs
			try {
				// on récupère les données depuis le service qui interroge le serveur
				const typeFormat = await this.SitesTypesService.getCaracteristiques(typeId);
				// on trie le tableau selon la propriété 'position'
				// on publie le tableau dans le this pour l'afficher dans la vue
				this.typeFormat = this._.sortBy(typeFormat, 'position');
				this.onCaracteristiquesCount({
					count: this.typeFormat.length
				});
				this.Interpreteur.formatCaract = this.typeFormat;
			} catch (ex) {
				// en cas de problème on notifie l'utilisateur
				this.notification.error(ex.data);
			} finally {
				// On supprimer le timeout précédent (fuite mémoire)
				this.$timeout.cancel(this.typeFormatTimeout);

				// une fois l'appel terminé, on stoppe l'animation de loading
				this.typeFormatTimeout = this.$timeout(() => {
					this.stopLoading();
				});

				if (this.typeFormat?.length > 0) {
					this.typeFormat = this.typeFormat.map((format) => {
						format.isDisabled = !this.hasUserAccess;
						return format;
					});
				}
			}
		}
	}

	async exitCaract(idCaract) {
		if (!this.ignoreDoCheck) {
			this.ignoreDoCheck = true;
			const nouvValeur = this.caracteristiquesTransporteur[idCaract];
			let updateListeCar = false;
			if (!this.caracteristiquesTransporteur.data[idCaract]) {
				updateListeCar = true;
			} else if (this.caracteristiquesTransporteur.data[idCaract] != nouvValeur) {
				updateListeCar = true;
				this.site.caracteristiquesTransporteur[idCaract] = nouvValeur;
				this.site.caracteristiquesTransporteur.data[idCaract] = nouvValeur;
				if (this.caracteristiquesTransporteur.data[idCaract] !== undefined) {
					this.caracteristiquesTransporteur.data[idCaract].value = nouvValeur;
				}
			}
			if (updateListeCar) {
				await this.recalculeFormules();
				this.onUpdate({
					caracteristiquesTransporteur: angular.copy(this.caracteristiquesTransporteur)
				});
				await this.recalculeConditions();
			}
			this.ignoreDoCheck = false;
		}
	}

	async recalculeFormules() {
		let recharge = false;
		if (this.Interpreteur) {
			this.Interpreteur.calculatedFormules = [];
			this.Interpreteur.obj = this.site;
			this.Interpreteur.obj.caracteristiques = this.Interpreteur.obj.caracteristiquesTransporteur;
			this.Interpreteur.formatCaract = this.typeFormat;
		}
		let idx1 = 0;
		while (idx1 < this.typeFormat.length) {
			const format = this.typeFormat[idx1];
			if (format.formula) {
				try {
					const oldVal = this.caracteristiquesTransporteur[idx1];
					this.Interpreteur.essaiAppel = undefined;
					this.Interpreteur.forceIter = undefined;
					let newVal = await this.Interpreteur.calculeFormule(format.formula);
					if (format.nature == 'Numerique' && newVal !== '') {
						let arrondi = format.numericAdditionalInformation.nombreDeDecimales;
						const grandeurMinimum = format.numericAdditionalInformation.grandeurMinimum;
						const grandeurMaximum = format.numericAdditionalInformation.grandeurMaximum;
						const x = this.Interpreteur.strEnDouble(newVal);
						if (!isNaN(x)) {
							//gestion des min/max
							if (grandeurMinimum != undefined && grandeurMinimum != null && grandeurMinimum > newVal) {
								newVal = grandeurMinimum;
							}
							if (grandeurMaximum != undefined && grandeurMaximum != null && grandeurMaximum < newVal) {
								newVal = grandeurMaximum;
							}
							//gestion de l'arrondi
							if (arrondi == 0) {
								newVal = Math.round(x);
							} else {
								if (!arrondi) {
									arrondi = 2;
								}
								newVal = x.toFixed(arrondi);
							}
						} else {
							newVal = null;
						}
					}
					if (oldVal !== newVal) {
						this.caracteristiquesTransporteur[format.id] = newVal;
						if (this.caracteristiquesTransporteur.data) {
							this.caracteristiquesTransporteur.data[format.id].value = newVal;
						}
						recharge = true;
					}
				} catch (ex) {
					console.error(ex);
				}
			}
			idx1++;
		}
		if (recharge) {
			this.typeFormat = angular.copy(this.typeFormat);
		}
	}

	async recalculeConditions() {
		if (this.typeFormat) {
			let rechargeCond = false;
			if (this.Interpreteur) {
				this.Interpreteur.calculatedFormules = [];
				this.Interpreteur.obj = this.site;
				this.Interpreteur.obj.caracteristiques = this.Interpreteur.obj.caracteristiquesTransporteur;
				this.Interpreteur.formatCaract = this.typeFormat;
			}
			let idx1 = 0;
			while (idx1 < this.typeFormat.length) {
				const format = this.typeFormat[idx1];
				if (format.condition) {
					try {
						const oldCond = angular.copy(format.hide);
						this.Interpreteur.essaiAppel = undefined;
						this.Interpreteur.forceIter = undefined;
						const newCond = await this.Interpreteur.calculeFormule(format.condition);

						if (oldCond !== (newCond !== true && newCond !== 'true')) {
							format.hide = newCond !== true && newCond !== 'true';
							rechargeCond = true;
						}
					} catch (ex) {
						console.error(ex);
					}
				}
				idx1++;
			}
			if (rechargeCond) {
				this.typeFormat = angular.copy(this.typeFormat);
			}
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
